export default "__VITE_ASSET__X08A8qiU__"